var map = {
	"./celeb_icon.jpg": "rtRV",
	"./fam_a.png": "7dLW",
	"./fam_b.png": "LsZV",
	"./ind_a.png": "4D0p",
	"./ind_b.png": "CUMj",
	"./logo.png": "7Otq",
	"./none_icon.jpg": "NeO4",
	"./shadow_vert.png": "nwJe",
	"./socios_icon.jpg": "vxui"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1